<template lang="pug">
  .cards.row.gutter-small
    loading-spinner.column(v-if='data.length === 0')
    .columns(v-for="d in data", :class="classes")
      .card
        .card-section
          a(v-if="d.callback", @click="d.callback.func()", :class="d.callback.class")
          b(v-html="d.title")
          h1(v-html="d.value" :style="{color: d.color}")
          .content(v-html="d.extra")
</template>
<script type="text/babel">
  import LoadingSpinner from './LoadingSpinner'
  import Dropdown from './foundation/Dropdown'

  export default {
    name: 'Cards',
    components: {
      Dropdown,
      LoadingSpinner
    },
    props: ['data'],
    computed: {
      classes: function () {
        if (this.data.length === 1) {
          return 'small-12'
        } else {
          return 'small-12 medium-4 large-3'
        }
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .cards
    b
      text-transform: uppercase

    .loading-spinner
      margin: 25px !important


    .card-section
      position: relative

      a
        position: absolute
        right: 0
        margin-right: 1em
</style>



// WEBPACK FOOTER //
// Cards.vue?58fd1106